import React from 'react';
import { ShieldAlert } from 'lucide-react';

export const COMPLIANCE_TEXT =
  'Any unethical use of this app (misleading advertisements, privacy violations, fake claims, etc.) is strictly prohibited and is an offence punishable under ASCI Code, IT Act 2000, Consumer Protection Act 2019 and other applicable Indian laws.';

export default function ComplianceBanner({ compact = false }) {
  // Inline styles to bypass the global amber→green override (kept amber on purpose
  // as a regulatory/legal warning surface, visually distinct from brand surfaces).
  return (
    <div
      data-testid="compliance-banner"
      className={`rounded-xl ${compact ? 'p-3' : 'p-4'} flex gap-3 items-start`}
      style={{
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor: 'rgba(245, 158, 11, 0.35)',
        background: 'rgba(245, 158, 11, 0.06)',
      }}
    >
      <ShieldAlert className="h-5 w-5 flex-shrink-0 mt-0.5" style={{ color: '#fbbf24' }} />
      <div>
        <div
          className="text-xs uppercase font-bold tracking-wider mb-1"
          style={{ color: '#fcd34d' }}
        >
          Compliance Notice
        </div>
        <p className={`${compact ? 'text-xs' : 'text-sm'} leading-relaxed`} style={{ color: '#fde68a' }}>
          {COMPLIANCE_TEXT}
        </p>
      </div>
    </div>
  );
}
